// extracted by mini-css-extract-plugin
export default {"documentItem":"Document_documentItem__wOA3i","newsItem":"Document_newsItem__DY9nY","title":"Document_title__X76gw","textContent":"Document_textContent__I5IET"};